module.exports = __webpack_public_path__ + "static/77invgde-899003d0c80ce5bb92dce33953e9d377.gif";